"use client";

import * as React from "react";

export type AuditModalFilters = {
  title?: string;
  parentEntity?: string;
  parentId?: number;
  childEntity?: string;
  childId?: number;
  controllerName?: string;
  onlyStatusChanges?: boolean;
};

type AuditModalState = {
  isOpen: boolean;
  filters?: AuditModalFilters;
};

type AuditModalCtxValue = {
  open: (filters?: AuditModalFilters) => void;
  close: () => void;
  state: AuditModalState;
};

// ✅ اسم Context رو عوض کردم تا با هیچ چیز تداخل نکنه
const AuditLogsModalCtx = React.createContext<AuditModalCtxValue | undefined>(undefined);

export function AuditLogsModalProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = React.useState<AuditModalState>({
    isOpen: false,
    filters: undefined,
  });

  const open = React.useCallback((filters?: AuditModalFilters) => {
    setState({ isOpen: true, filters });
  }, []);

  const close = React.useCallback(() => {
    setState((s) => ({ ...s, isOpen: false }));
  }, []);

  const value = React.useMemo<AuditModalCtxValue>(
    () => ({ open, close, state }),
    [open, close, state]
  );

  return React.createElement(AuditLogsModalCtx.Provider, { value }, children);
}

export function useAuditLogsModal() {
  const ctx = React.useContext(AuditLogsModalCtx);
  if (!ctx) throw new Error("useAuditLogsModal must be used inside AuditLogsModalProvider");
  return ctx;
}
